import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHero, Loading, Empty, PromiseBadge, PROMISE_LABELS, fmtMoney } from "@/components/common";

export default function Promesometro() {
  const [items, setItems] = useState(null);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    const params = filter ? { promise_status: filter } : {};
    setItems(null);
    api.get("/promises", { params }).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [filter]);

  return (
    <div data-testid="promesometro-page">
      <PageHero label="Promesómetro" title="Seguimiento de promesas"
        subtitle="Cada compromiso público con su responsable, fecha, presupuesto, avance y evidencia. Clasificación transparente y verificable." />
      <div className="max-w-6xl mx-auto px-6 py-10">
        <div className="flex flex-wrap gap-2 mb-8">
          <button onClick={() => setFilter("")} data-testid="promise-filter-all"
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${filter === "" ? "bg-slate-900 text-white" : "bg-white border border-slate-200 text-slate-600 hover:bg-slate-100"}`}>Todas</button>
          {Object.entries(PROMISE_LABELS).map(([k, v]) => (
            <button key={k} onClick={() => setFilter(k)} data-testid={`promise-filter-${k}`}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${filter === k ? "bg-slate-900 text-white" : "bg-white border border-slate-200 text-slate-600 hover:bg-slate-100"}`}>{v}</button>
          ))}
        </div>
        {items === null ? <Loading /> : items.length === 0 ? <Empty label="No hay promesas con este estado." /> : (
          <div className="space-y-4">
            {items.map((p) => (
              <div key={p.id} data-testid={`promise-card-${p.id}`} className="bg-white rounded-lg border border-slate-200 p-6">
                <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3 mb-4">
                  <div>
                    <h3 className="font-heading font-bold text-xl text-slate-900">{p.title}</h3>
                    <p className="text-sm text-slate-500 mt-1">{p.responsible}</p>
                  </div>
                  <PromiseBadge status={p.promise_status} />
                </div>
                <p className="text-slate-600 text-sm mb-4">{p.description}</p>
                <div className="h-2.5 bg-slate-100 rounded-full overflow-hidden mb-2">
                  <div className="h-full bg-cyan-500 rounded-full transition-all" style={{ width: `${p.progress}%` }} />
                </div>
                <div className="flex flex-wrap gap-x-6 gap-y-1 text-xs text-slate-500">
                  <span>{p.progress}% de avance</span>
                  {p.promised_date && <span>Fecha: {p.promised_date}</span>}
                  {p.budget != null && <span>Presupuesto: {fmtMoney(p.budget)}</span>}
                  {p.source && <span>Fuente: {p.source}</span>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
